import { NavigationViewMap, NavigationGroup } from './navigation';

export class User {
    id: number;
    email: string;
    // password: string;
    firstName: string;
    lastName: string;
    token: string;
    refreshToken: string;
    tokenExpiry: Date;
    groups: Array<NavigationGroup>;
    views: NavigationViewMap;
    loggedIn: boolean;
    readOnly: boolean;
    orgId: number;
    userHash: string;
    hideOtp: boolean;
    pageActions: { [key: string]: [value: string] };
}
